// extracted by mini-css-extract-plugin
export default {"form":"style_form__ecPyh"};